import React from "react";
import { Box, Typography } from "@mui/material";

function Header({ showHeader }) {
  return (
    <Box
      p={2}
      height={64}
      display={"flex"}
      alignItems={"center"}
      // visibility={showHeader ? "visible" : "hidden"}
    >
      <Typography variant="h6">All Sessions</Typography>
    </Box>
  );
}

export default Header;
